// @ngInject
function PaymentTermsApiService(ResourcesService) {

  var endpoint = 'paymentterms';

  return {
    getPaymentTerms: ResourcesService.apiFactory.get(endpoint),
    getPaymentTerm: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createPaymentTerm: ResourcesService.apiFactory.create(endpoint, 'PaymentTerm'),
    updatePaymentTerm: ResourcesService.apiFactory.update(endpoint, 'PaymentTerm'),
    deletePaymentTerm: ResourcesService.apiFactory.delete(endpoint, 'PaymentTerm')
  };

}

angular
  .module('paymentterms.api', [])
  .factory('PaymentTermsApiService', PaymentTermsApiService);
